/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Ledg API
 * API for managing financial activities and transactions
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  ApiAppDataResponse,
  ErrorResponse,
  RefreshResponse
} from './client.schemas'




/**
 * @summary Refresh insights for a specific account
 */
export const refreshAccountInsights = (
    accountId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshResponse>> => {
    
    return axios.default.post(
      `/v2/accounts/v2/accounts/${accountId}/insights/refresh`,undefined,options
    );
  }



export const getRefreshAccountInsightsMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccountInsights>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccountInsights>>, TError,{accountId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccountInsights>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  refreshAccountInsights(accountId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshAccountInsightsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccountInsights>>>
    
    export type RefreshAccountInsightsMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Refresh insights for a specific account
 */
export const useRefreshAccountInsights = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccountInsights>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof refreshAccountInsights>>,
        TError,
        {accountId: string},
        TContext
      > => {

      const mutationOptions = getRefreshAccountInsightsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Refresh an entire account: sync all import sources, retag, and regenerate insights
 */
export const refreshAccount = (
    accountId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshResponse>> => {
    
    return axios.default.post(
      `/v2/accounts/v2/accounts/${accountId}/refresh`,undefined,options
    );
  }



export const getRefreshAccountMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,{accountId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccount>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  refreshAccount(accountId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccount>>>
    
    export type RefreshAccountMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Refresh an entire account: sync all import sources, retag, and regenerate insights
 */
export const useRefreshAccount = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof refreshAccount>>,
        TError,
        {accountId: string},
        TContext
      > => {

      const mutationOptions = getRefreshAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Refresh tags for all activity groups in an account
 */
export const refreshAccountTags = (
    accountId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RefreshResponse>> => {
    
    return axios.default.post(
      `/v2/accounts/v2/accounts/${accountId}/tags/refresh`,undefined,options
    );
  }



export const getRefreshAccountTagsMutationOptions = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccountTags>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccountTags>>, TError,{accountId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccountTags>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  refreshAccountTags(accountId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshAccountTagsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccountTags>>>
    
    export type RefreshAccountTagsMutationError = AxiosError<void | ErrorResponse>

    /**
 * @summary Refresh tags for all activity groups in an account
 */
export const useRefreshAccountTags = <TError = AxiosError<void | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccountTags>>, TError,{accountId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof refreshAccountTags>>,
        TError,
        {accountId: string},
        TContext
      > => {

      const mutationOptions = getRefreshAccountTagsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get app data including subscription tier and account insights
 */
export const getAppData = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiAppDataResponse>> => {
    
    return axios.default.get(
      `/v2/app_data`,options
    );
  }


export const getGetAppDataQueryKey = () => {
    return [`/v2/app_data`] as const;
    }

    
export const getGetAppDataQueryOptions = <TData = Awaited<ReturnType<typeof getAppData>>, TError = AxiosError<void | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppDataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppData>>> = ({ signal }) => getAppData({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAppData>>>
export type GetAppDataQueryError = AxiosError<void | ErrorResponse>

/**
 * @summary Get app data including subscription tier and account insights
 */
export const useGetAppData = <TData = Awaited<ReturnType<typeof getAppData>>, TError = AxiosError<void | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppData>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAppDataQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



